/** The model of a task as one readable line, or null when no run recorded one. */
export function taskModelLabel(
  modelProvider: string | null | undefined,
  modelId: string | null | undefined,
): string | null {
  const id = modelId?.trim();
  if (!id) return null;
  const provider = modelProvider?.trim();
  return provider ? `${provider} · ${id}` : id;
}
